/**
 * Cart operations handler for product bundles
 * Handles adding items to cart and form submission
 */
(function() {
    'use strict';
    
    window.BundleCartHandler = window.BundleCartHandler || {};

    /**
     * Collect all items from bundle for cart
     * @param {HTMLElement} bundleElement - The bundle element
     * @param {Function} debugLog - Debug logging function
     * @param {Function} debugError - Debug error function
     * @returns {Array} Array of items with id and quantity
     */
    window.BundleCartHandler.collectBundleItems = function(bundleElement, debugLog, debugError) {
    const bundleItem = bundleElement.querySelectorAll('.bundle-product-item.isChecked');
    let items = [];
    
    debugLog('🛒 [ProductBundle] === COLLECTING ITEMS FOR CART ===');
    debugLog('🛒 [ProductBundle] Found checked bundle items:', bundleItem.length);
    
    // ALWAYS include the first item (main product) even if not explicitly checked
    const firstItem = bundleElement.querySelector('.bundle-product-itemFirst, .bundle-product-item:first-child');
    const checkedItems = Array.from(bundleItem);
    
    // Ensure first item is included
    if (firstItem && !checkedItems.includes(firstItem)) {
        debugLog('Adding first item (main product) to cart');
        checkedItems.unshift(firstItem);
    }
    
    checkedItems.forEach((item, index) => {
        const variantSelect = item.querySelector('select[name=group_id]');
        const variantInput = item.querySelector('input[name=group_id]');
        const variantElement = variantSelect || variantInput;
        
        if (!variantElement) {
            debugError(`❌ Bundle item ${index + 1}: No [name=group_id] element found`);
            return;
        }
        
        let variantId = null;
        
        // If it's a select, get the selected option's value
        if (variantSelect) {
            if (variantSelect.selectedIndex >= 0 && variantSelect.options[variantSelect.selectedIndex]) {
                const selectedOption = variantSelect.options[variantSelect.selectedIndex];
                variantId = selectedOption.value;
            } else {
                // Try to find first non-disabled option
                const firstAvailableOption = Array.from(variantSelect.options).find(opt => !opt.disabled && opt.value);
                if (firstAvailableOption) {
                    variantId = firstAvailableOption.value;
                    variantSelect.selectedIndex = Array.from(variantSelect.options).indexOf(firstAvailableOption);
                }
            }
        } else if (variantInput) {
            variantId = variantInput.value;
        }
        
        if (!variantId || variantId.toString().trim() === '') {
            debugError(`❌ Bundle item ${index + 1}: Empty variant ID`);
            return;
        }
        
        // Convert to integer (Shopify requires numeric IDs)
        const variantIdInt = parseInt(variantId.toString().trim(), 10);
        if (isNaN(variantIdInt) || variantIdInt <= 0) {
            debugError(`❌ Bundle item ${index + 1}: Invalid variant ID: ${variantId}`);
            return;
        }
        
        items.push({ id: variantIdInt, quantity: 1 });
        debugLog(`✅ Bundle item ${index + 1}: Added variantId=${variantIdInt}`);
    });
    
        return items;
    };

    /**
     * Validate items array before sending to cart
     * @param {Array} items - Items array
     * @param {Function} debugError - Debug error function
     * @returns {boolean} True if valid
     */
    window.BundleCartHandler.validateItems = function(items, debugError) {
    if (items.length === 0) {
        debugError('❌ [ProductBundle] CRITICAL ERROR: No valid items to add to cart!');
        return false;
    }
    
    const invalidItems = items.filter(item => !item.id || item.id <= 0 || !Number.isInteger(item.id));
    if (invalidItems.length > 0) {
        debugError('❌ [ProductBundle] CRITICAL ERROR: Invalid items found!');
        debugError('❌ [ProductBundle] Invalid items:', JSON.stringify(invalidItems, null, 2));
        return false;
    }
    
        return true;
    };

    /**
     * Add items to cart
     * @param {Array} items - Items array
     * @param {Function} debugLog - Debug logging function
     * @param {Function} debugError - Debug error function
     * @returns {Promise} Cart response
     */
    window.BundleCartHandler.addItemsToCart = async function(items, debugLog, debugError) {
    const requestPayload = { items: items };
    
    debugLog('🛒 [ProductBundle] === ADDING ITEMS TO CART ===');
    debugLog('🛒 [ProductBundle] Request payload:', JSON.stringify(requestPayload, null, 2));
    
    if (!Array.isArray(items) || items.length === 0) {
        throw new Error('Items array is empty or invalid');
    }
    
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload)
    });
    
    if (!response.ok) {
        const errorText = await response.text();
        debugError('❌ [ProductBundle] Cart API error:', errorText);
        throw new Error(`Cart API error: ${response.status} ${errorText}`);
    }
    
    const cartData = await response.json();
        debugLog('✅ [ProductBundle] Items added to cart successfully');
        
        return cartData;
    };
})();
